import { combineReducers, configureStore } from "@reduxjs/toolkit";
import coreReducer from "./reducer";
import { CORE_ACTION } from "./types/CoreAction";

const reducers = combineReducers({
  coreState: coreReducer,
  // ...other reducers
});

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          CORE_ACTION.UPDATE_DIALOG,
          CORE_ACTION.ADD_DOWNLOAD_SNACK,
          CORE_ACTION.UPDATE_DOWNLOAD_SNACK,
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: [
          "meta.arg",
          "payload.coreState.dialog",
          "payload.coreState.downloadSnacks",
        ],
        // Ignore these paths in the state
        ignoredPaths: ["coreState.dialog", "coreState.downloadSnacks"],
      },
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
